import ActiveModel from "@/apis/ActiveModel";
import Cursado from "@/apisNew/Cursado";

const END_POINT = "new-cursados";

const actions = {
  async getCursadosActivos({ commit }, bundle) {
    try {
      // console.log("bundle",bundle);
      const { status, data } = await Cursado.activas(bundle);
      if (status === 200) {
        commit("setModels", data);
      }
    } catch (e) {
      console.log(e);
      commit("setErrors", e.response ? e.response.data : e);
    }
  },

  async crearCicloLectivo({ commit }, form) {
    // console.log(form);
    try {
      const { status, data } = await Cursado.crearCicloLectivo(form);
      if (status === 200) {
        commit("addModels", data);
      }
    } catch (e) {
      commit("setErrors", e.response ? e.response.data : e);
    }
  },
  async dividirComision({ commit }, comision) {
    // console.log(form);
    try {
      const { status, data } = await Cursado.dividirComision(comision);
      if (status === 200) {
        console.log("comision agregada");
        commit("addModel", data);
      }
    } catch (e) {
      commit("setErrors", e.response ? e.response.data : e);
    }
  },

  async getCursados({ commit }, bundle) {
    try {
      const { status, data } = await ActiveModel.all(END_POINT, bundle);
      if (status === 200) {
        commit("setModels", data);
      }
    } catch (e) {
      console.log(e);
      commit("setErrors", e.response ? e.response.data : e);
    }
  },
  async getCursado({ commit }, payload) {
    try {
      let id, expand;
      // Soportar llamada con id simple o con objeto {id, expand}
      if (typeof payload === "object") {
        id = payload.id;
        expand = payload.expand;
      } else {
        id = payload;
      }

      let response;
      if (expand) {
        response = await ActiveModel.viewWithParams(END_POINT, id, { expand });
      } else {
        response = await ActiveModel.view(END_POINT, id);
      }

      if (response.status === 200) {
        commit("setModel", response.data);
      }
    } catch (e) {
      console.log(e);
      commit("setErrors", e.response ? e.response.data : e);
    }
  },

  async addCursado({ commit }, item) {
    try {
      const { status, data } = await ActiveModel.store(END_POINT, item);
      if (status === 201) {
        console.log("registro creado");
        commit("addModel", data);
      }
    } catch (e) {
      commit("setErrors", e.response ? e.response.data : e);
    }
  },

  async deleteCursado({ commit }, id) {
    try {
      const { status } = await ActiveModel.delete(END_POINT, id);
      if (status === 204) {
        commit("delModel", id);
      }
    } catch (e) {
      commit("setErrors", e.response ? e.response.data : e);
    }
  },
  async updateCursado({ commit }, model) {
    try {
      const { status, data } = await ActiveModel.update(END_POINT, model);
      if (status === 200) {
        commit("updateModel", data);
      }
    } catch (e) {
      commit("setErrors", e.response ? e.response.data : e);
    }
  },

  async getFields({ commit }) {
    try {
      const { status, data } = await ActiveModel.model(END_POINT);
      if (status === 200) {
        commit("setFields", data);
      }
    } catch (e) {
      console.log(e);
      commit("setErrors", e.response ? e.response.data : e);
    }
  },
};
export default actions;
